import React, { useState } from 'react';

export default function SectionFooter({
  respondentId,
  formHandler,
  disableSave,
  partialSaveHandler,
  isSectionFive = false
}) {
  const [isSaving, setSaving] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isReturning, setReturning] = useState(false);

  const handlePartialSaveButtonClick = () => {
    setSaving(true);
    partialSaveHandler(true);
  };

  const handleSubmitButtonClick = () => {
    setSubmitting(true);
    formHandler();
  };

  return (
    <div className="sales-portal__footer">
      <a
        href={`/sales-report-portal/dashboard?respondent_id=${respondentId}`}
        className={`btn btn--outline sales-portal__return-dashboard-bottom ${
          isReturning ? 'btn--loading' : ''
        }`}
        onClick={() => setReturning(true)}
      >
        <span className="btn__content">
          <span className="btn__text">Return to Dashboard</span>
        </span>
      </a>
      {isSectionFive && (
        <button
          onClick={handlePartialSaveButtonClick}
          className={`btn btn--outline sales-portal__save-btn-bottom ${
            isSaving ? 'btn--loading' : ''
          }`}
        >
          <span className="btn__content">
            <span className="btn__text">Save and Complete Later</span>
          </span>
        </button>
      )}
      <button
        id="app-section-continue-button"
        onClick={handleSubmitButtonClick}
        className={`btn btn--primary sales-portal__save-btn-bottom ${
          isSubmitting ? 'btn--loading' : ''
        }`}
        disabled={disableSave}
      >
        <span className="btn__content">
          <span className="btn__text">Save</span>
        </span>
      </button>
    </div>
  );
}
